import { api } from "../api";
import type {
  FaceCheckLogItem,
  FaceCheckLogVerifyResult,
  PaginatedResponse,
} from "../../types/domain";

export const faceCheckLogService = {
  list: (params?: {
    skip?: number;
    limit?: number;
    matched?: boolean;
    user_id?: string;
    date_from?: string;
    date_to?: string;
  }) => {
    const query = new URLSearchParams();
    if (params?.skip != null) query.set("skip", String(params.skip));
    if (params?.limit != null) query.set("limit", String(params.limit));
    if (params?.matched != null) query.set("matched", String(params.matched));
    if (params?.user_id) query.set("user_id", params.user_id);
    if (params?.date_from) query.set("date_from", params.date_from);
    if (params?.date_to) query.set("date_to", params.date_to);
    const qs = query.toString();
    return api.get<PaginatedResponse<FaceCheckLogItem>>(
      `/face-check-logs${qs ? `?${qs}` : ""}`
    );
  },

  verify: (logId: string, compareUserId?: string) => {
    const qs = compareUserId ? `?compare_user_id=${compareUserId}` : "";
    return api.get<FaceCheckLogVerifyResult>(`/face-check-logs/${logId}/verify${qs}`);
  },
};
